<template>
  <div v-show="closesAt">
    <div>
      <!-- 本日締切 -->
      <span
        v-show="showNotification === 'today'"
        class="co-display-13 font-bold"
      >
        <img
          class="mr-2 inline"
          src="~/assets/images/Te/TeCourse/CoverTimeSpan/icon-flame-danger-1.svg"
          alt=""
          width="12"
          height="16"
          style="margin-bottom: 0.125rem"
        >
        本日締切：
        <span class="mx-1">{{ closesMonth }}</span>月
        <span class="mx-1">{{ closesDays }}</span>日 （{{ closesDayOfWeek }}）
        <span class="mx-1">{{ closesHours }}</span>時
      </span>

      <!-- 締切間近 -->
      <span
        v-show="showNotification === 'aLittleLeft'"
        class="co-display-13 font-bold"
      >
        <img
          class="mr-2 inline"
          src="~/assets/images/Te/TeCourse/CoverTimeSpan/icon-flame-danger-1.svg"
          alt=""
          width="12"
          height="16"
          style="margin-bottom: 0.125rem"
        >
        締切間近：
        <span class="mx-1">{{ closesMonth }}</span>月
        <span class="mx-1">{{ closesDays }}</span>日 （{{ closesDayOfWeek }}）
        <span class="mx-1">{{ closesHours }}</span>時
      </span>

      <!-- 申込締切日 -->
      <span
        v-show="showNotification === 'left'"
        class="co-display-13 font-bold"
      >
        申込締切日：
        <span class="mx-1">{{ closesMonth }}</span>月
        <span class="mx-1">{{ closesDays }}</span>日 （{{ closesDayOfWeek }}）
        <span class="mx-1">{{ closesHours }}</span>時
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { dateToYesterday, formatDayOfWeek } from '~/utility/utility'

const options = {
  props: {
    closesAt: {
      type: Date,
      default: null,
    },
  },
  computed: {
    closesHours(): number {
      if (!this.closesAt) {
        return 0
      }
      return this.closesAt.getHours() + 24
    },
    closesDays(): number {
      if (!this.closesAt) {
        return 0
      }
      if (this.closesAt.getDate() === 1) {
        const yesterday = new Date(this.closesAt)
        yesterday.setDate(yesterday.getDate() - 1)
        return yesterday.getDate()
      }
      return this.closesAt.getDate() - 1
    },
    closesMonth(): number {
      if (!this.closesAt) {
        return 0
      }
      if (this.closesAt.getDate() === 1) {
        const yesterday = new Date(this.closesAt)
        yesterday.setDate(yesterday.getDate() - 1)
        return yesterday.getMonth() + 1
      }
      return this.closesAt.getMonth() + 1
    },
    closesDayOfWeek(): '日' | '月' | '火' | '水' | '木' | '金' | '土' | '祝' {
      if (!this.closesAt) {
        return '日'
      }
      const dayOfWeek = formatDayOfWeek(dateToYesterday(this.closesAt), false)

      return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土' | '祝'
    },
    showNotification(): 'today' | 'aLittleLeft' | 'left' {
      if (!this.closesAt) {
        return 'left'
      }
      const now = new Date()
      const leftDays =
        (this.closesAt.valueOf() - now.valueOf()) / (1000 * 60 * 60 * 24)
      if (leftDays >= 0 && leftDays < 1) {
        return 'today'
      } else if (leftDays >= 1 && leftDays < 3) {
        return 'aLittleLeft'
      } else {
        return 'left'
      }
    },
  },
}

export default defineNuxtComponent(options)
</script>
